//CSS
import "../../Components/Page/Page.css";
import "./TimeLine.css";

//React
import React, { useState } from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewsReleases from "../../Components/Article/NewsReleases.json";
import Button2 from "../../Components/Button2/Button2";

interface TimelineText {
  headLine: string;
  text: string;
  readMore: string;
}

const Featured: React.FC = () => {

  const [featured, setFeatured] = useState([0, 5]);
  return (
    <div className="sectionContainer">
      <SecHeader title="Featured Releases" />

      <SubSection isSplit={false}>

        <div className="description-container">
          {featured.map((int, index) => (

            <div key={index}>
              <div className="news-header">
                <FontAwesomeIcon
                  className="news-icon"
                  icon={faNewspaper}
                  size="2x"
                />
                <b className="news-title">
                  {NewsReleases[int].publishedAt
                    ? new Date(NewsReleases[int].publishedAt).toLocaleDateString(
                      "en-US",
                      {
                        month: "long",
                        year: "numeric",
                      },
                    )
                    : null}{" "}
                  - {NewsReleases[int].title}
                </b>
              </div>

              <p>{NewsReleases[int].excerpt}</p>
              <Button2
                name="readMore"
                text="Read more..."
                href={`/article/${NewsReleases[int].slug}`}
                classname="ctaButton"
              />
              <br />
            </div>
          ))}

        </div>
      </SubSection>
    </div>
  );
};

export default Featured;
